import Leagues from "@Enums/Leagues";
import { getMedalBackgroundColor, getMedalImage, getMedalImageFromRating } from "@Helpers/medal-utils";
import { Box, SxProps, useTheme } from "@mui/material";
import { FC } from "react";

interface IBybMedalElement {
  league?: Leagues;
  rating?: number;
  size?: number;
  includeBackground?: boolean;
  sx?: SxProps;
}

const BybMedalElement: FC<IBybMedalElement> = ({ league, rating, size, includeBackground = false, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minWidth: theme.spacing(4),
        minHeight: theme.spacing(4),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: theme.spacing(size || 4),
        height: theme.spacing(size || 4),
        backgroundSize: "cover",
        borderRadius: theme.spacing(1.5),
        ...(includeBackground
          ? {
              backgroundImage: league ? getMedalBackgroundColor(league, theme) : undefined,
            }
          : {}),
        ...sx,
      }}
    >
      <img
        src={league ? getMedalImage(league) : rating !== undefined ? getMedalImageFromRating(rating) : ""}
        alt="Medal"
        width={theme.spacing(size || 4)}
        height={theme.spacing(size || 4)}
      />
    </Box>
  );
};

export default BybMedalElement;
